import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AdminSearch from "./component";
import { getAssessmentAttemptByUserId } from "../dashboard/actions";
import { GetUserById, isGuestOrPremiumUser } from "../settings/actions";
import { downloadAssessmentResult } from "../confirmation/actions";
import AdminUserDocuments from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAssessmentAttemptByUserIdConnect: getAssessmentAttemptByUserId,
      GetUserByIdConnect: GetUserById,
      IsGuestOrPremiumUserConnect: isGuestOrPremiumUser,
      DownloadAssessmentResultConnect: downloadAssessmentResult,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserDocuments);
